import React from 'react';
import {ImageOverlay} from 'react-leaflet';
import {connect} from 'react-redux';
import {addLoadedTimes, incrementLoadingIndex} from '../actions';
import {geoserverBase} from '../config/environment';
import {utcToLocal} from '../utils/time_utils';

class IndicatorOverlays extends React.Component {

  render() {
    const { indicator, time, playing, dispatch, loading_index, intervals, dragging } = this.props;
    if (indicator) {
      const wms_time = indicator && indicator.local_time_for_wms ?
                       utcToLocal(time.display_time) :
                       time.display_time;
      if (loading_index < intervals.length) {
        return Array(loading_index + 1).fill().map((_, i) => {
          const interval = intervals[i];
          const intervalStart = interval.starting_at;
          return <ImageOverlay
            url={(indicator.base || geoserverBase) +
                 indicator.source +
                 'service=WMS&version=1.1.0&request=GetMap&layers=' +
                 indicator.params.layers +
                 '&tiled=TRUE&styles=&transparent=TRUE&bbox=15683578.939447,-4832575.139308,16815264.470097,-4019406.419603&width=154&height=110&srs=EPSG:3857&format=image%2Fpng&time=' +
                 intervalStart}
            bounds={[[-33.929998627233346, 151.05409088134766], [-39.76999832100885, 140.8879867553711]]}
            opacity={intervalStart === wms_time && (playing || dragging) ? 0.7 : 0}
            zIndex={2}
            key={indicator.prefix + intervalStart}
            onload={() => {
              if (loading_index + 1 < intervals.length) {
                dispatch(incrementLoadingIndex());
              }
              dispatch(addLoadedTimes(interval.contained_periods));
            }}/>;
        });
      }
    }
    return null;
  }
}

const mapStateToProps = state => {
  return {
    indicator: state.indicators.active,
    time: state.time,
    playing: state.play.playing,
    loading_index: state.indicator_overlays.loading_index,
    intervals: state.indicator_overlays.intervals,
    dragging: state.timeline_dnd.dragging
  };
};

const mapDispatchToProps = dispatch => {
  return {
    dispatch: dispatch
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(IndicatorOverlays);



// WEBPACK FOOTER //
// ./src/containers/IndicatorOverlays.js